import src from "IMAGE";
export default { src, width: 526, height: 526, blurWidth: 0, blurHeight: 0};
